module.exports = __webpack_public_path__ + "assets/images/cockpit/hover/btn_settings-hover_ru.png";